import { BucketFunctionApiEnum } from '../../../api/mentions/enum/bucket-function-api.enum';
import { EngagementAgeApiEnum } from '../../../api/mentions/enum/engagement-age-api.enum';
import { NeoFacetTermFieldApiEnum } from '../../../api/mentions/enum/neo-facet-term-field-api.enum';
import { NeoFacetPrefixApiEnum } from '../../../api/mentions/model/neo-facet-prefix-api.enum';
import { NeoFacetRequestApiModel } from '../../../api/mentions/model/neo-facet-request-api.model';
import { SocialSeriesNeoFacetKeysEnum } from '../enums/social-series-neo-facet-keys.enum';

export const mediaTypeNeoFacetRequest: NeoFacetRequestApiModel = {
    termField: NeoFacetTermFieldApiEnum.MEDIA_TYPE,
    key: SocialSeriesNeoFacetKeysEnum.mediaTypeFacetGroup,
    engagementBucketRequests: [
        {
            key: SocialSeriesNeoFacetKeysEnum.mediaTypeEngagements,
            field: NeoFacetTermFieldApiEnum.ENGAGEMENT_TOTAL,
            engagementAge: EngagementAgeApiEnum.LATEST,
            function: BucketFunctionApiEnum.INDIVIDUAL_SUM
        },
    ],
    aggregateBucketRequests: [
        {
            key: SocialSeriesNeoFacetKeysEnum.mediaTypeImpressions,
            field: NeoFacetTermFieldApiEnum.AUDIENCE_REACH,
            function: BucketFunctionApiEnum.INDIVIDUAL_SUM
        }
    ]
};

export const engagementsNeoFacetRequest: NeoFacetRequestApiModel = {
    termField: NeoFacetTermFieldApiEnum.MEDIA_TYPE,
    key: SocialSeriesNeoFacetKeysEnum.totalEngagements,
    engagementBucketRequests: [
        {   // likes
            key: SocialSeriesNeoFacetKeysEnum.engagementTotalLikes,
            field: NeoFacetTermFieldApiEnum.LIKE,
            engagementAge: EngagementAgeApiEnum.LATEST,
            function: BucketFunctionApiEnum.INDIVIDUAL_SUM
        },
        {   // quotes
            key: SocialSeriesNeoFacetKeysEnum.engagementTotalQuotes,
            field: NeoFacetTermFieldApiEnum.QUOTE,
            engagementAge: EngagementAgeApiEnum.LATEST,
            function: BucketFunctionApiEnum.INDIVIDUAL_SUM
        },
        {   // replies
            key: SocialSeriesNeoFacetKeysEnum.engagementTotalReply,
            field: NeoFacetTermFieldApiEnum.REPLY,
            engagementAge: EngagementAgeApiEnum.LATEST,
            function: BucketFunctionApiEnum.INDIVIDUAL_SUM
        },
        {   // retweets
            key: SocialSeriesNeoFacetKeysEnum.engagementTotalShare,
            field: NeoFacetTermFieldApiEnum.SHARE,
            engagementAge: EngagementAgeApiEnum.LATEST,
            function: BucketFunctionApiEnum.INDIVIDUAL_SUM
        },
        {   // views
            key: SocialSeriesNeoFacetKeysEnum.engagementTotalView,
            field: NeoFacetTermFieldApiEnum.VIEW,
            engagementAge: EngagementAgeApiEnum.LATEST,
            function: BucketFunctionApiEnum.INDIVIDUAL_SUM
        },
    ],
    aggregateBucketRequests: []
};

export const mentionsByEngagementNeoFacetRequest: NeoFacetRequestApiModel = {
    termField: NeoFacetTermFieldApiEnum.MENTIONS,
    key: SocialSeriesNeoFacetKeysEnum.mentionsEngagements,
    engagementBucketRequests: [
        {   // likes
            key: SocialSeriesNeoFacetKeysEnum.engagementTotalLikes,
            field: NeoFacetTermFieldApiEnum.LIKE,
            engagementAge: EngagementAgeApiEnum.LATEST,
            function: BucketFunctionApiEnum.INDIVIDUAL_SUM
        },
        {   // quotes
            key: SocialSeriesNeoFacetKeysEnum.engagementTotalQuotes,
            field: NeoFacetTermFieldApiEnum.QUOTE,
            engagementAge: EngagementAgeApiEnum.LATEST,
            function: BucketFunctionApiEnum.INDIVIDUAL_SUM
        },
        {   // replies
            key: SocialSeriesNeoFacetKeysEnum.engagementTotalReply,
            field: NeoFacetTermFieldApiEnum.REPLY,
            engagementAge: EngagementAgeApiEnum.LATEST,
            function: BucketFunctionApiEnum.INDIVIDUAL_SUM
        },
        {   // retweets
            key: SocialSeriesNeoFacetKeysEnum.engagementTotalShare,
            field: NeoFacetTermFieldApiEnum.SHARE,
            engagementAge: EngagementAgeApiEnum.LATEST,
            function: BucketFunctionApiEnum.INDIVIDUAL_SUM
        },
        {   // views
            key: SocialSeriesNeoFacetKeysEnum.engagementTotalView,
            field: NeoFacetTermFieldApiEnum.VIEW,
            engagementAge: EngagementAgeApiEnum.LATEST,
            function: BucketFunctionApiEnum.INDIVIDUAL_SUM
        },
    ],
    aggregateBucketRequests: [],
    prefix: NeoFacetPrefixApiEnum.hashtag
};

export const mentionsByImpressionsNeoFacetRequest: NeoFacetRequestApiModel = {
    termField: NeoFacetTermFieldApiEnum.MENTIONS,
    key: SocialSeriesNeoFacetKeysEnum.mentionsEngagements,
    engagementBucketRequests: [],
    aggregateBucketRequests: [
        {
            key: SocialSeriesNeoFacetKeysEnum.mentionsImpressions,
            field: NeoFacetTermFieldApiEnum.AUDIENCE_REACH,
            function: BucketFunctionApiEnum.INDIVIDUAL_SUM
        }
    ],
    prefix: NeoFacetPrefixApiEnum.hashtag
};
